import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { bonuses } from '../data/content';
export function ValueStack() {
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-214" data-mp="1qapetfs1e5s6">
      <div className="mx-auto max-w-4xl px-5" data-id="element-215" data-mp="1uapypfxwn96m">
        <SectionHeading eyebrow="Bonos gratis" title="Además de la guía, hoy te llevás 6 bonos exclusivos" subtitle="Totalmente gratis al acceder hoy — todo lo que necesitás para resolver la rutina completa." data-id="element-216" data-mp="2hzith92sjazn" />
        <div className="mt-12 space-y-4" data-id="element-217" data-mp="296fm9iiqnudg">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-center gap-4 rounded-2xl border border-beige bg-white p-4 shadow-sm sm:gap-6 sm:p-5" data-id="element-218" data-mp="2d80x6ybppyl0" data-mpi={i}>
              <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-green-soft text-3xl sm:h-20 sm:w-20 sm:text-4xl" data-id="element-219" data-mp="1oh1oirxinbg2">
                {b.emoji}
              </div>
              <div className="min-w-0 flex-1" data-id="element-220" data-mp="1ye6b2sv9x8xe">
                <span className="text-[11px] font-extrabold uppercase tracking-widest text-green-brand" data-id="element-221" data-mp="1ycd2v950igna">
                  {b.n}
                </span>
                <h3 className="font-display text-base font-bold leading-snug text-green-deep sm:text-lg" data-id="element-222" data-mp="2850yw1o64gky">
                  {b.title}
                </h3>
                <p className="mt-1 hidden text-sm leading-relaxed text-[#5A6656] sm:block" data-id="element-223" data-mp="2m1xvykuvquaa">
                  {b.body}
                </p>
              </div>
              <div className="shrink-0 text-right" data-id="element-224" data-mp="rr2ib44u8p0n">
                <span className="block text-[10px] font-bold uppercase tracking-wide text-[#9AA093]" data-id="element-225" data-mp="mqwjn405i292">
                  Valor
                </span>
                <span className="font-display text-base font-black text-green-deep line-through decoration-2 sm:text-lg" data-id="element-226" data-mp="2muh8pnlzeyyf">
                  {b.value}
                </span>
              </div>
            </motion.div>)}
        </div>
        {/* Total value box */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5
      }} className="mt-10 overflow-hidden rounded-3xl bg-green-deep p-8 text-center text-white shadow-xl" data-id="element-227" data-mp="30tgo04nlu1hx">
          <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-extrabold uppercase tracking-wide text-yellow-brand" data-id="element-228" data-mp="3fj4myz8bco2h">
            <GiftIcon className="h-4 w-4" data-id="element-229" data-mp="3oj1gpf9k8d4e" /> Todo el paquete
          </div>
          <p className="text-lg font-semibold text-white/80" data-id="element-230" data-mp="3thm76mz0fifn">El valor de todo esto podría ser:</p>
          <p className="mt-1 font-display text-3xl font-bold text-white/60 line-through" data-id="element-231" data-mp="3tf9vgrjui4b1">
            $27.980
          </p>
          <p className="mt-4 text-lg font-semibold text-white/90" data-id="element-232" data-mp="2gizfcey1mfs">Pero hoy accedés por solo:</p>
          <p className="font-display text-5xl font-black text-yellow-brand sm:text-6xl" data-id="element-233" data-mp="3tmtv0t16puzq">
            $13.990
          </p>
          <div className="mt-7 flex justify-center" data-id="element-234" data-mp="3pmtgz9hzzlt7">
            <CTAButton data-id="element-235" data-mp="q6n47n3vbs8d">Quiero todo con 50% OFF</CTAButton>
          </div>
        </motion.div>
      </div>
    </section>;
}